import React, { useEffect } from "react";
import "./TransactionsCmp.scss";
import History from "./History/History";
import Transfer from "./Transfer/Transfer";
import {
  useGetMainQuery,
} from "services/clientApi";
import { useNavigate } from "react-router-dom";

const Transactions = ({ isHistory, setIsHistory }) => {
  const navigate = useNavigate();
  const { data: main, isLoading: loading, isError: error, refetch } = useGetMainQuery();
  const logOut = () => {
    localStorage.removeItem("isClient");
    localStorage.removeItem("auth_client");
    navigate("/login");
    window.location.reload();
  };

  if (error) {
    logOut()
  }

  useEffect(() => {
    refetch();
    const interval = setInterval(() => {
      refetch();
    }, 60000);

    return () => clearInterval(interval);
  }, [refetch]);

  return (
    <div>
      <div className="w-100 h-100 ">
        {isHistory ? (
          <History setIsHistory={setIsHistory} />
        ) : (
          <Transfer setIsHistory={setIsHistory} />
        )}
      </div>
    </div>
  );
};

export default Transactions;
